import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { get } from "lodash";
import { getEhrRoute } from "../../../utils/getEhrRoute";
import BarLoader from "./../../../common/Loader/BarLoader";
import { Button, Icon } from "@unite-us/app-components/";
import { CLIENTS } from "../../../../api/config/config";
import { useUpdateConversation } from "../../../../hooks/useUpdateConversation";
import { useConversationMeta } from "../../../../hooks/useConversationMeta";
import { getReferralDetails } from "../../../../hooks/getReferralDetails";
import { getCaseDetails } from "../../../../hooks/getCaseDetails";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
function ConversationHeader(_ref) {
  var _currentConversation$, _currentConversation$2, _recipient$provider, _currentConversation$3;
  let {
    currentConversation,
    currentEmployeeId,
    source,
    headerLinksEnabled,
    resetState,
    messageCenterLogger,
    toast,
    archiveEnabled
  } = _ref;
  const [caseDetails, setCaseDetails] = useState(null);
  const [referral, setReferral] = useState(null);
  const recipient = currentConversation.participants.find(emp => emp.id !== currentEmployeeId);
  const personId = get(currentConversation, "attributes.client.id", false);
  const subjectId = get(currentConversation, "attributes.subject_id", false);
  const subjectType = currentConversation.subjectType;
  const personName = get(currentConversation, "attributes.client.name", false);
  const topicName = get(currentConversation, "attributes.service.name", false);
  const isEhr = source === "emr";
  useEffect(() => {
    if (subjectType === "referral") {
      const fetchReferral = async () => {
        const response = await getReferralDetails(subjectId);
        setReferral(response);
      };
      fetchReferral();
    }
    if (subjectType === "case") {
      const fetchCase = async () => {
        const response = await getCaseDetails(subjectId);
        setCaseDetails(response);
      };
      fetchCase();
    }
  }, [(_currentConversation$ = currentConversation.case) === null || _currentConversation$ === void 0 ? void 0 : _currentConversation$.id, (_currentConversation$2 = currentConversation.referral) === null || _currentConversation$2 === void 0 ? void 0 : _currentConversation$2.id, subjectId, subjectType]);
  const mapState = state => {
    const stateMapping = {
      sent: "all",
      auto_recalled: "all",
      declined: "rejected",
      pending: "open",
      resolved: "closed"
    };
    if (!state) return;
    return stateMapping[state] || state;
  };
  const redirectToCase = () => {
    const allProvidersMatch = currentConversation.participants.every(participant => participant.provider.id === currentConversation.participants[0].provider.id);
    const caseType = allProvidersMatch ? "cases" : "external-cases";
    const state = mapState(caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.resolution);
    return "/dashboard/".concat(caseType, "/").concat(state, "/").concat(subjectId, "/contact/").concat(personId);
  };
  const redirectToReferral = () => {
    const allProvidersMatch = currentConversation.participants.every(participant => participant.provider.id === currentConversation.participants[0].provider.id);
    const state = mapState(referral === null || referral === void 0 ? void 0 : referral.state);
    const referralType = allProvidersMatch ? "new/referrals" : "referrals/sent/".concat(state);
    return "/dashboard/".concat(referralType, "/").concat(subjectId);
  };
  const redirectToReferralOrCase = () => {
    if (subjectType === "case") {
      return redirectToCase();
    }
    return redirectToReferral();
  };
  const facesheetLink = isEhr ? getEhrRoute("client", personId, subjectType, subjectId) : "/facesheet/".concat(personId);
  const topicLink = isEhr ? getEhrRoute("topic", personId, subjectType, subjectId) : redirectToReferralOrCase();
  const {
    apiMessagingService
  } = CLIENTS;
  const {
    totalMessages
  } = useConversationMeta(currentConversation === null || currentConversation === void 0 ? void 0 : currentConversation.sid, currentConversation === null || currentConversation === void 0 ? void 0 : currentConversation.totalMessages);
  const hasUnreadMessagesByRecepient = recipient.lastReadMessageIndex !== totalMessages;
  const {
    toggleArchiveState
  } = useUpdateConversation({
    currentConversation,
    resetState,
    messageCenterLogger,
    toast,
    apiMessagingService,
    hasUnreadMessagesByRecepient
  });
  return /*#__PURE__*/_jsx("div", {
    className: "mb-1",
    children: currentConversation && /*#__PURE__*/_jsxs("div", {
      className: "conversation-header",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex justify-between",
        children: [recipient && /*#__PURE__*/_jsxs("div", {
          className: "strong text-xl ".concat(archiveEnabled ? "" : "pb-2"),
          children: [recipient.name, " (", (_recipient$provider = recipient.provider) === null || _recipient$provider === void 0 ? void 0 : _recipient$provider.name, ")"]
        }), archiveEnabled && /*#__PURE__*/_jsx(Button, {
          id: "archive-button",
          outline: true,
          label: (currentConversation === null || currentConversation === void 0 || (_currentConversation$3 = currentConversation.state) === null || _currentConversation$3 === void 0 ? void 0 : _currentConversation$3.current) === "active" ? "Archive" : "Unarchive",
          onClick: toggleArchiveState,
          icon: {
            name: 'Archive',
            color: '#4467AB',
            position: 'left'
          }
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "conversation-data flex flex-row",
        children: [personName ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("strong", {
            className: "text-base",
            children: " Client: "
          }), headerLinksEnabled ? /*#__PURE__*/_jsx(Link, {
            className: "ml-1 text-action-blue font-regular-font text-base",
            to: facesheetLink,
            reloadDocument: true,
            children: personName
          }) : /*#__PURE__*/_jsx("p", {
            className: "ml-1 text-action-blue font-regular-font text-base",
            children: personName
          })]
        }) : /*#__PURE__*/_jsx(BarLoader, {}), /*#__PURE__*/_jsx("span", {
          className: "mx-2",
          children: " | "
        }), topicName ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("strong", {
            className: "text-base",
            children: " Topic: "
          }), headerLinksEnabled ? /*#__PURE__*/_jsx(Link, {
            className: "ml-1 text-action-blue font-regular-font text-base",
            to: topicLink,
            reloadDocument: true,
            children: topicName
          }) : /*#__PURE__*/_jsx("p", {
            className: "ml-1 text-action-blue font-regular-font text-base",
            children: topicName
          })]
        }) : /*#__PURE__*/_jsx(BarLoader, {})]
      })]
    })
  });
}
export default ConversationHeader;
//# sourceMappingURL=conversationHeader.js.map